import { Outlet } from 'react-router-dom';
import ECommerceLayout from '@/app/(dashboard)/e-commerce/layout';
export function ECommerceLayoutWrapper() {
  return (
    <ECommerceLayout>
      <Outlet />
    </ECommerceLayout>
  );
}
